import {
  declineSOPayment,
  UserActivityInfoRequest,
  cancelSOPaymentTransactionAPIV2,
} from '../../../api/smartbestbuys-api'

import { RejectFormValues } from './SOPaymentRejectDialog'

export const rejectPaymentTransaction = (saleOrderId: number, transationId: number, values: RejectFormValues) => {
  const { actionMessage, actionMessageId } = values
  const request: UserActivityInfoRequest = {
    actionMessageId: actionMessageId === -1 ? undefined : actionMessageId,
    actionMessage,
  }

  return declineSOPayment(saleOrderId)(transationId, request)
}

export const cancelPaymentTransaction = async (saleOrderId: number, transationId: number, values: RejectFormValues) => {
  const { actionMessage, actionMessageId } = values
  const request: UserActivityInfoRequest = {
    actionMessageId: actionMessageId === -1 ? undefined : actionMessageId,
    actionMessage,
  }

  const response = await cancelSOPaymentTransactionAPIV2(saleOrderId)(transationId, request)
  return response?.data
}
